import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { useTranslation } from "react-i18next";

import http from "../services/http";

import AmenitiesList from "../pages/AmenitiesList";
import AmenitiesPreview from "../pages/AmenitiesPreview";

import ListingsList from "../pages/ListingsList";
import ListingDetails from "../pages/ListingDetails";
import ListingsPreview from "../pages/ListingsPreview";
import ListingListState from "../components-shared/ListingListState";

import CalendarBoard from "../pages/CalendarBoard";

import {
  selectWebsiteFont,
  selectWebsiteTheme,
  selectWebsiteLoaded,
  setWebsite,
  getWebsite,
  selectWebsiteId,
  selectWebsiteLng,
  selectWebsiteError,
} from "../store/slices/website";

import { ThemeStyle, Loading } from "./styled";

function Navigation() {
  const dispatch = useDispatch();
  const { i18n } = useTranslation();

  const [isReady, setIsReady] = useState(false);

  const websiteId = useSelector(selectWebsiteId);
  const isWebsiteLoaded = useSelector(selectWebsiteLoaded);
  const font = useSelector(selectWebsiteFont);
  const lng = useSelector(selectWebsiteLng);
  const error = useSelector(selectWebsiteError);

  const { colors } = useSelector(selectWebsiteTheme);

  useEffect(() => {
    const { search } = window.location;
    const params = new URLSearchParams(search);
    const website_id = params.get("website_id");

    try {
      new ResizeObserver(([event]) => {
        window.parent.postMessage(
          {
            clListingsHeight: event.target.clientHeight,
          },
          "*",
        );
      }).observe(window.document.body);
    } catch (e) {
      console.error(e);
    }

    if (website_id) {
      dispatch(setWebsite(website_id));
    }
  }, [dispatch]);

  useEffect(() => {
    if (!lng) {
      return;
    }

    http.defaults.headers.common["accept-language"] = lng;
    i18n.changeLanguage(lng);
  }, [lng, i18n]);

  useEffect(() => {
    if (!isWebsiteLoaded || !lng) {
      return;
    }

    setTimeout(() => {
      setIsReady(true);
    }, 100);
  }, [isWebsiteLoaded, lng]);

  useEffect(() => {
    if (!websiteId) {
      return;
    }
    dispatch(getWebsite({ website_id: websiteId }));
  }, [websiteId, dispatch]);

  useEffect(() => {
    if (!font) {
      return;
    }

    const head = window.document.getElementsByTagName("head")[0];
    const headerFontElement = window.document.createElement("link");
    const bodyFontElement = window.document.createElement("link");
    headerFontElement.setAttribute("href", font.header_font_url);
    headerFontElement.setAttribute("rel", "stylesheet");

    bodyFontElement.setAttribute("href", font.body_font_url);
    bodyFontElement.setAttribute("rel", "stylesheet");

    head.append(headerFontElement);
    head.append(bodyFontElement);
  }, [font]);

  if (!websiteId || error) {
    return <ListingListState type="error" />;
  }

  if (!isReady) {
    return (
      <Loading>
        <div className="loader" />
      </Loading>
    );
  }

  return (
    <>
      <ThemeStyle font={font} colors={colors} />

      <Router>
        <Routes>
          <Route exact path="/" element={<ListingsList />} />
          <Route exact path="/grid" element={<ListingsList />} />
          <Route exact path="/carousel" element={<ListingsPreview />} />
          <Route exact path=":id/details" element={<ListingDetails />} />

          <Route exact path="/amenities" element={<AmenitiesList />} />
          <Route exact path="/amenities/grid" element={<AmenitiesList />} />
          <Route
            exact
            path="/amenities/carousel"
            element={<AmenitiesPreview />}
          />

          <Route exact path="/calendar" element={<CalendarBoard />} />

          <Route path="*" element={<ListingListState type="not_found_404" />} />
        </Routes>
      </Router>
    </>
  );
}

export default Navigation;
